import React from "react";

export default function ExpandIcon({ className, onClick }) {
  return (
    <svg
      width="20"
      height="20"
      x="0"
      y="0"
      viewBox="0 0 512 512"
      className={className}
      onClick={onClick}
      //   style="enable-background:new 0 0 512 512"
    >
      <g>
        <path
          d="M181.2 32a32 32 0 0 1-32 32H64v85.2a32 32 0 0 1-64 0V32A32 32 0 0 1 32 0h117.2a32 32 0 0 1 32 32zm-32 416H64v-85.2a32 32 0 0 0-64 0V480a32 32 0 0 0 32 32h117.2a32 32 0 1 0 0-64zM480 330.8a32 32 0 0 0-32 32V448h-85.2a32 32 0 1 0 0 64H480a32 32 0 0 0 32-32V362.8a32 32 0 0 0-32-32zM480 0H362.8a32 32 0 0 0 0 64H448v85.2a32 32 0 1 0 64 0V32a32 32 0 0 0-32-32z"
          fill="#ffffff"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  );
}
